import { ClipboardCheck, PhoneCall, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { api } from "@/api";
import { errText } from "@/components/pipeline/utils";

// Bandeau « X fiches à débriefer » du Cockpit
export const DebriefBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/debriefs/summary").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s || !(s.ready + s.waiting)) return null;
  return (
    <Link to="/debrief" className="ck-debrief" data-testid="ck-debrief-banner">
      <ClipboardCheck size={18} /><strong>{s.ready + s.waiting} fiche{s.ready + s.waiting > 1 ? "s" : ""} à débriefer</strong>
      <span>{s.ready} prête{s.ready > 1 ? "s" : ""}{s.waiting ? ` · ${s.waiting} en attente de transcription` : ""}</span><em>Débriefer →</em>
    </Link>
  );
};

// Démo admin : simule une session de 5 appels transcrits, puis ouvre le débrief
export const DemoSessionButtons = () => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/call-sessions/demo");
      toast.success("Session de 5 appels simulée : l'IA prépare le débrief…");
      navigate(`/debrief?session=${data.session_id}`);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    const { data } = await api.delete("/call-sessions/demo");
    toast.success(`Démo supprimée (${data.deleted.debriefs} débriefs, ${data.deleted.ai_proposals} propositions).`);
  };
  return (
    <>
      <button type="button" disabled={busy} onClick={create} data-testid="ck-demo-session"><PhoneCall size={14} /> {busy ? "Simulation…" : "Simuler une session (5 appels)"}</button>
      <button type="button" onClick={remove} data-testid="ck-demo-session-delete"><Trash2 size={14} /> Supprimer la session démo</button>
    </>
  );
};
